import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/siteData";

export default function WhyUseSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full mb-4">
              Why Choose Us
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              Why Use Our BaseTao Spreadsheet Guides
            </h2>
            <div className="space-y-5">
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-lg text-primary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">Independent &amp; Unbiased</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Our content is produced by an independent research team with no affiliation to BaseTao. We prioritize honest analysis, transparent methodology, and editorial integrity above all else.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-refresh-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">Regularly Updated</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Shipping costs, coupon codes, and platform features change frequently. We update our guides every month to reflect the latest information.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-guide-line text-lg text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">Comprehensive Coverage</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    From beginner tutorials to advanced optimization strategies, our BaseTao Spreadsheet resources cover every aspect of the shopping workflow.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div
              className="w-full aspect-[4/3] rounded-2xl bg-cover bg-center border border-background-200/70"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20fashion%20styling%20flat%20lay%20with%20carefully%20arranged%20clothing%20items%20sneakers%20and%20accessories%20on%20a%20cream%20linen%20surface%2C%20soft%20natural%20window%20light%2C%20sage%20green%20botanical%20accents%2C%20minimalist%20aesthetic%20composition%2C%20editorial%20fashion%20photography%2C%20high%20detail%2C%20warm%20inviting%20tones%2C%20organized%20luxury%20shopping%20display&width=800&height=600&seq=why-use-v3&orientation=landscape&nocache=true')`,
              }}
            ></div>
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
            <Link
              to="/article/basetao-spreadsheet-guide"
              className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
            >
              Read Our Complete Guide
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-6 py-3 border-2 border-foreground-200 text-foreground-800 font-semibold text-sm rounded-md hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
            >
              Shop on BaseTao
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}